/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize, layers } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

/*
  Make Atlaskit Tabs sticky in the sidebar with vertical scrolling

  * 1.
    Parent component <ExpandedSidebar/> wraps sidebar content and has padding
    Source: src/components/sidebar/src/styles.ts
    Keep <Tabs/> fixed to top of sidebar by adding padding and negative margin

  * 2.
    Offset sticky panel headings using <Tabs/> heading fixed height
    Source: src/components/sidebar/src/expander/expander.tsx
*/
const TABS_HEADING_HEIGHT = '33px';
export const StickyTabsWrapper = styled.div({
  '> div': {
    '> div:first-of-type': {
      backgroundColor: token('color.background.input'),
      height: TABS_HEADING_HEIGHT,
      marginTop: `-${gridSize() / 2}px` /* 1 */,
      paddingTop: `${gridSize() / 2}px` /* 1 */,
      position: 'sticky',
      top: 0,
      zIndex: layers.card(),
    },
    '.sidebar-expander-panel-heading': {
      top: TABS_HEADING_HEIGHT /* 2 */,
    },
  },
  /* To counter-balance the padding of the ExpandedSidebar styling */
  margin: `0 -${gridSize()}px`,
});

export const ExpandedSidebarContent = styled.div({
  width: '100%',
  minHeight: `${gridSize() * 50}px`,
  overflowY: 'visible',
});

export const SidebarTab = styled.div({
  marginTop: `${gridSize()}px`,
  '&:empty': {
    marginTop: 0,
  },
});

export const SidebarTabItem = styled.div({
  display: 'flex',
  alignItems: 'center',
});

export const FileTreeTabLabel = styled.span({
  paddingRight: `${gridSize() / 2}px`,
});

export const MergeConflictIcon = styled.div({
  display: 'flex',
});
